import BCliente from "./BCliente"
import Desplegable from "./Desplegable"
import DPaquete from "./TablaDCliente"
import { useSelector } from "react-redux"
const Cabecera = () => {
    const { referencia } = useSelector(store => store.cambios)
    return (
        <div>
            <BCliente />
            {
                (referencia) ? (
                    <>
                        <DPaquete />
                        <Desplegable />
                    </>
                ) :
                    <div>
                        Seleccione un cliente
                    </div>
            }
        </div>
    )
}
export default Cabecera